import {
  AppstoreOutlined,
  AuditOutlined,
  BankOutlined,
  CommentOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  HomeOutlined,
  InfoCircleOutlined,
  LineChartOutlined,
  OrderedListOutlined,
  PieChartOutlined,
  SendOutlined,
  TagOutlined,
  TeamOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import type { ReactNode } from 'react';
import type { MessageKeys } from 'types/intl';
import { FinancingIcon } from './icons/FinancingIcon';
import { CaseSidebarItemId } from '../types';

interface CaseSidebarItemConfig {
  titleKey: MessageKeys;
  icon: ReactNode;
}

export const CASE_SIDEBAR_ITEMS: Record<CaseSidebarItemId, CaseSidebarItemConfig> = {
  [CaseSidebarItemId.OVERVIEW]: {
    titleKey: 'caseSidebar.pages.overview',
    icon: <AppstoreOutlined />,
  },
  [CaseSidebarItemId.CUSTOMER_FILES]: {
    titleKey: 'caseSidebar.pages.customerFiles',
    icon: <FileTextOutlined />,
  },
  [CaseSidebarItemId.EVIDENCE]: {
    titleKey: 'caseSidebar.pages.evidence',
    icon: <FileSearchOutlined />,
  },
  [CaseSidebarItemId.FINANCING]: {
    titleKey: 'caseSidebar.pages.financing',
    icon: <FinancingIcon />,
  },
  [CaseSidebarItemId.APPLICANTS]: {
    titleKey: 'btlApplicationForm.APPLICANTS.label',
    icon: <TeamOutlined />,
  },
  [CaseSidebarItemId.EXPENSES]: {
    titleKey: 'caseSidebar.pages.expenses',
    icon: <PieChartOutlined />,
  },
  [CaseSidebarItemId.PRODUCT]: {
    titleKey: 'btlApplicationForm.PRODUCT.label',
    icon: <TagOutlined />,
  },
  [CaseSidebarItemId.PROPERTY]: {
    titleKey: 'caseSidebar.pages.property',
    icon: <HomeOutlined />,
  },
  [CaseSidebarItemId.AFFORDABILITY_CHECK]: {
    titleKey: 'caseSidebar.pages.affordabilityCheck',
    icon: <OrderedListOutlined />,
  },
  [CaseSidebarItemId.TOP_SLICING]: {
    titleKey: 'btlApplicationForm.TOP_SLICING.label',
    icon: <PieChartOutlined />,
  },
  [CaseSidebarItemId.SUBMIT_DIP]: {
    titleKey: 'btlApplicationForm.SUBMIT_DIP.label',
    icon: <SendOutlined />,
  },
  [CaseSidebarItemId.SOLICITORS]: {
    titleKey: 'caseSidebar.pages.solicitor',
    icon: <AuditOutlined />,
  },
  [CaseSidebarItemId.BANK_DETAILS]: {
    titleKey: 'caseSidebar.pages.bankDetails',
    icon: <BankOutlined />,
  },
  [CaseSidebarItemId.SUBMIT_APPLICATION]: {
    titleKey: 'caseSidebar.pages.submitApplication',
    icon: <UploadOutlined />,
  },
  [CaseSidebarItemId.VALUATION]: {
    titleKey: 'applicationDetails.tabs.valuation',
    icon: <LineChartOutlined />,
  },
  [CaseSidebarItemId.POST_OFFER]: {
    titleKey: 'applicationDetails.tabs.postOffer',
    icon: <FileTextOutlined />,
  },
  [CaseSidebarItemId.COMMUNICATION]: {
    titleKey: 'applicationDetails.tabs.communication',
    icon: <CommentOutlined />,
  },
  [CaseSidebarItemId.ADDITIONAL_INFORMATION]: {
    titleKey: 'btlApplicationForm.ADDITIONAL_INFORMATION.label',
    icon: <InfoCircleOutlined />,
  },
};

export const ITEM_TITLE_KEYS = Object.fromEntries(
  Object.entries(CASE_SIDEBAR_ITEMS).map(([itemId, item]) => [itemId, item.titleKey]),
) as Record<CaseSidebarItemId, MessageKeys>;

export function getCaseSidebarItemIcon(itemId: CaseSidebarItemId): ReactNode {
  return CASE_SIDEBAR_ITEMS[itemId].icon;
}
